module.exports = {

    resources: {
        stationadopt: {
            name: 'Station Identity',
        }
    }
}
